import { VariantOption } from '../VariantOption';

export const overwriteBorderSelectionIfIncompatible = (
    oldBorderId: string | undefined,
    newSizeId: string,
    newPaperId: string | undefined,
    borderOptions: VariantOption[]
) => {

    let newBorderId: string | undefined = undefined;

    if (oldBorderId) {

        newBorderId = oldBorderId;

        const paper = borderOptions.find(p => p.value === oldBorderId);
        if (!isCompatible(paper, newSizeId, newPaperId)) {

            const defaultPaperForSize = borderOptions.find(p => isCompatible(p, newSizeId, newPaperId));

            if (defaultPaperForSize) {
                newBorderId = defaultPaperForSize.value;
            }
        }
    }

    return newBorderId;
};

const isCompatible = (border: VariantOption | undefined, sizeId: string, paperId: string | undefined) => {
    return border && border.compatibleWith.find(item => item.sizeId === sizeId && item.paperId === paperId);
};